import { Tooltip } from "bootstrap";
import { MapSlidePanel } from "./MapSidePanel";
import { MapViewStore } from "./MapViewStore";
import olMap from 'ol/Map';
import * as olInteraction from 'ol/interaction';
import { BaseLayerFactory, BaseLayerType } from "./BaseLayerFactory";
import BaseLayer from "ol/layer/Base";
import { BingSession } from "./BingSession";
import LayerGroup from 'ol/layer/Group';
import VectorLayer from 'ol/layer/Vector';
import { Options } from 'ol/layer/BaseVector';
import { MapStyleFactory } from "./MapStyleFactory";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Icon from 'ol/style/Icon';
import WKT from 'ol/format/WKT';
import * as olExtent from 'ol/extent';
import { MapBrowserEvent, Overlay, View } from "ol";
import MousePosition from 'ol/control/MousePosition';
import ScaleLine from 'ol/control/ScaleLine';
import FullScreen from 'ol/control/FullScreen';
import { OSGB, WGS84 } from "esdm-gridreference";
import { Coordinate } from "ol/coordinate";
import Fill from "ol/style/Fill";
import Text from "ol/style/Text";
import Circle from "ol/style/Circle";
import Stroke from "ol/style/Stroke";
import ImageWMS from 'ol/source/ImageWMS';
import ImageLayer from 'ol/layer/Image';

import proj4 from "proj4";
import * as olProj from 'ol/proj';
import Projection from "ol/proj/Projection";
import { register } from 'ol/proj/proj4'
import { MapContextMenu } from "./MapContextMenu";
import Layer from "ol/layer/Layer";
import { AppStorage } from "./AppStorage";
import { MapHighlightFeatures } from "./MapHighlightFeatures";
import { MapFeatureInfo } from "./MapfeatureInfo";
import { Draw } from "ol/interaction";
import * as olSphere from 'ol/sphere';
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import { unByKey } from 'ol/Observable';
import { DrawEvent } from "ol/interaction/Draw";
import GeometryType from "ol/geom/GeometryType";
import OverlayPositioning from "ol/OverlayPositioning";
import { MapGazetteer } from "./MapGazetteer";
import { AppGeoLocation } from "./AppGeoLocation";
import TrailwiseEventBus from './TrailwiseEventBus';
import { MapGpx } from "./MapGpx";
import { MapGridRef } from "./MapGridRef";
import { debounce } from "debounce";

$(function () {
    const mapData = $("#mapData");

    const isAuth: boolean = mapData.data("auth");
    const wmsurl: string = mapData.data("wmsurl");
    const bingMapsApiKey: string = mapData.data("bingMapsApiKey");
    const osmApiKey: string = mapData.data("osmApiKey");
    const maxFeatures: number = mapData.data("maxFeatures");
    const isMember: boolean = mapData.data("isMember");
    const routeType = mapData.data("routeType");
    const RouteId = mapData.data("RouteId");
    const model = mapData.data("model");
    const showProw = mapData.data("prow");
    const bingSession = new BingSession();
    let map: MainMap = null;

    const resizeMap = function () {        
        let height = $(window).height() - $("#mapContainer").offset().top - $("footer").height();
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);

        if (map) {
            map.olMap.updateSize();
        }
        //$("#slide-content").height(height - 75);
    };

    const loadMap = function (bingApiOrSessionKey: string) {
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));  
        map = new MainMap(wmsurl, osmApiKey, bingApiOrSessionKey, "login", "register", maxFeatures, isAuth, isMember, bingSession, showProw);
    }

    const loadMapWithoutBing = function () {
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));
        map = new MainMap(wmsurl, osmApiKey, null, "login", "register", maxFeatures, isAuth, isMember, null, showProw);
    }

    if (!isMember) {
        //unauth
        loadMap(bingMapsApiKey);
    } else {
        //Called via callback on bing map control js file
        const loadMapWithBingSession = function () {
            bingSession.init(bingMapsApiKey,
                function (bingSessionKey) { loadMap(bingSessionKey); },
                function () { loadMapWithoutBing(); }
            );
        }
        window["loadMapWithBingSession"] = loadMapWithBingSession;
        
        //deal with download failure of Bing Maps js
        window["loadMapWithoutBing"] = loadMapWithoutBing;
    }

    //resize map when user closes login alert
    var loginAlert = $('#content .alert:first-child');   
    if (loginAlert[0] != null) {
        loginAlert[0].addEventListener('closed.bs.alert', function () {
            resizeMap();
        })
    }    

});


proj4.defs([
    [
        'EPSG:27700',
        '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999601 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +no_defs +towgs84=446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894'
    ]
]);


//<div id="mapData"
//     data-wmsurl="@Html.Raw(scriptSettings.WmsUrl)"
//     data-disqusCountScript="@disqusCommentCountScriptPath"
//     data-auth="@isAuthenticated.ToString().ToLower()"
//     data-bing-maps-api-key="@scriptSettings.BingMapsApiKey"
//     data-osm-api-key="@scriptSettings.OsmContouredApiKey"
//     data-max-features="@scriptSettings.MaxFeatures"
//     data-is-member="@isMember.ToString().ToLower()"
//     data-login-url="@ViewData["LoginUrl"]"
//     data-register-url="@ViewData["RegisterUrlUrl"]"></div>
export class MainMap {

    private _map: olMap;
    private _mapId = "map";
    private _mapStoreID = "trailwise-map";
    private _mapStore: MapViewStore;
    private _mapSlidePanel: MapSlidePanel;
    private _initialised = false;
    private _loadingCount = 0;
    private _OS_extent: olExtent.Extent = [-841259.18, 6405988.48, 404314.68, 8733289.16];
    private _baseLayerFactory: BaseLayerFactory;
    private _BingOS: BaseLayer;
    private _BingRoad: BaseLayer;
    private _OSOpen: BaseLayer;
    private _OSMContoured: BaseLayer;
    private _hasTouch: boolean;
    private _contextMenu: MapContextMenu;
    private _maxUnauthenticatedZoom: number = 9; //20km
    private _hideRoutesOfNoInterest: number = 0;   
    private _showFavourites: number = 1;
    private _overlays: Map<string, Layer>;
    private _storage: AppStorage;
    private _mapHighlight: MapHighlightFeatures;
    private _mapFeatureInfo: MapFeatureInfo;
    private _sketch: Feature = null;
    private _draw: Draw = null;;
    private _helpTooltipElement: HTMLDivElement;
    private _helpTooltip: Overlay;
    private _measureLayer: VectorLayer;
    private _measureInKm: boolean = true;
    private _measureTooltipElement: HTMLDivElement;
    private _measureTooltip: Overlay;
    private _mapGazetteer: MapGazetteer;
    private _geoLocation: AppGeoLocation;
    private _mapGpx: MapGpx;
    private _mapGridRef: MapGridRef;
    private _selectedBaseLayerRadioId: string = "";
    get olMap() {
        return this._map;
    }

    public constructor(
        private _wfsUrl: string,
        private _osmContouredApiKey: string,
        private _bingApiOrSessionKey: string,
        private _loginUrl: string,
        private _registerUrl: string,
        private _maxFeatures: number,
        private _isAuthenticated: boolean,
        private _isMember: boolean,
        private _bingSession: BingSession,
        private _showBOATProw: number
    ) {
        let self = this;
        register(proj4);

        this._hasTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints > 0);
        //$("#slide-content").height($("#mapContainer").height() - 75);
        
        //init tooltips
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
        });

        this._storage = new AppStorage();
        this._mapStore = new MapViewStore(this._mapStoreID);        
       
        //mapStore.clear();
        this._mapSlidePanel = new MapSlidePanel(this._mapStore, true, true);
        this._map = this.getMap();                  
        this._mapStore.initMap(this._map, true);
        this.initRoutesOfNoInterest();
        this.initFavourites();       
        this.addMapControls(this._map);        
        this.addBaseLayers();
        this.addOverlays(this._map);

        this._map.on("singleclick", this.handleClick);
        this._map.on('pointermove', this.handlePointerMove);

        this._map.getViewport().addEventListener('mouseout', function (this: HTMLElement, ev: MouseEvent) {
            if (self._helpTooltipElement) {
                self._helpTooltipElement.classList.add('hidden');
            }
        });
        this.setMapView();
        this._mapHighlight = new MapHighlightFeatures(this._map, this._wfsUrl);
        this._mapFeatureInfo = new MapFeatureInfo(this._mapHighlight, this._showBOATProw === 1);

        this._contextMenu = new MapContextMenu(this._map);    

        let toolRadios = document.getElementsByName("currentTool");
        for (let i = 0; i < toolRadios.length; i++) {
            toolRadios[i].addEventListener("click", function (this: HTMLElement, ev: MouseEvent) {
                self.toolRadioClicked(this, ev);
            });
        }

        let currentMapState = this._mapStore.getMapInfo();
        //console.log(currentMapState);
        if (currentMapState.currentTool) {
            for (let i = 0; i < toolRadios.length; i++) {
                if ((<HTMLInputElement>toolRadios[i]).value === currentMapState.currentTool) {
                    toolRadios[i].click();
                }
            }
        }

        if (this._isAuthenticated) {
            setInterval(function () {
                self.checkAuthStatus();
            }, 120000); //every 2 minutes check if user is still authenticated
        }

        this._mapGazetteer = new MapGazetteer(this._map);
        this._geoLocation = new AppGeoLocation(this._map, this._OSMContoured);
        TrailwiseEventBus.trackingStart.on(function () {
            self.onTrackingStarted();
        });
        TrailwiseEventBus.trackingEnd.on(function () {
            self.onTrackingEnded();
        });

        this.initBookmarks();
        this._mapGpx = new MapGpx(this._map);
        this._mapGridRef = new MapGridRef(this._map,this._contextMenu);
    }

    private initBookmarks = (): void => {
        let self = this;

        let processTwuidResult = function (json) {
            console.log(json);
            $("#twuidLoading").hide();
            if (json.wkt) {
                let format = new WKT();
                let geom = format.readGeometry(json.wkt, {
                    dataProjection: "EPSG:27700",
                    featureProjection: "EPSG:3857"
                }); //parse WKT                
                let extent = geom.getExtent();
                self._map.getView().fit(extent, { maxZoom: 17, nearest: false });
            }            
        }

        $(".showOnMap").on("click", function () {
            let twuid = $(this).data("twuid");
            $("#twuidLoading").show();

            $.ajax({
                url: "/api/twuidsearch",
                data: { query: twuid },
                dataType: "json"
            })
                .done(function (json) {
                    $("#twuidLoading").hide();
                    processTwuidResult(json);
                })
                .fail(function () {
                    $("#twuidLoading").hide();
                });
        });
    }

    private getMap = (): olMap => {
        return new olMap({
            interactions: olInteraction.defaults({
                altShiftDragRotate: true,
                pinchRotate: true,
                mouseWheelZoom: false
            }).extend([
                new olInteraction.PinchZoom(),
                new olInteraction.MouseWheelZoom({
                    constrainResolution: true
                })
            ]),
            target: this._mapId,
            view: this.getView()
        });
    }

    private getView = (): View => {
        let self = this;

        let view = new View({
            projection: 'EPSG:3857',
            center: [-163269.4924, 6901652],
            minZoom: 7,
            maxZoom: 19,
            extent: this._OS_extent
        });

        if (!self._isMember) {
            view.setMaxZoom(this._maxUnauthenticatedZoom);
        }

        //listener fired whenever view resolution changes
        view.on("change:resolution", debounce(
            function (e) {
                let zoom = e.target.getZoom();    
                console.log("Zoom level:" + zoom);
                self.setBingOSView(zoom);                

                if (!self._isMember) {
                    // non auth users max zoom allowed is 4
                    if (zoom > self._maxUnauthenticatedZoom) {
                        self._map.getView().setZoom(self._maxUnauthenticatedZoom);
                    }
                }
                //update the legend graphics?
                //let resolution = evt.target.getResolution();
                //for (let layer in overlays) {
                //    if (overlays.hasOwnProperty(layer)) {
                //        let source = overlays[layer].getSource();
                //        console.log("updating legend: " + source.getParams().LAYERS);
                //        updateLegendGraphic(source, source.getParams().LAYERS, resolution);
                //    }
                //}            
            }            
            ,100));

        return view;
    }

    private setMapView = (): void => {
        let mapSettings = this._mapStore.getMapInfo();

        // only move map if there is no data to zoom to        
        if (mapSettings.centre && mapSettings.zoom) {
            this._map.getView().setCenter(mapSettings.centre);
            this._map.getView().setZoom(mapSettings.zoom);
        } else {
            //zoom to defaults if we don't have any on the cookie
            this._map.getView().setCenter([-163269.4924, 6901652]);
            this._map.getView().setZoom(11);
        }
    }

    private initFavourites = (): void => {
        let self = this;

        //check storage first
        self._showFavourites = parseInt(self._storage.getValue("ShowFavorites")) || 0;

        if (self._showFavourites === 1) {
            $("#chkShowFavourites").prop("checked", true);
        }

        $("#chkShowFavourites").on("change", function () {
            self._showFavourites = ($(this).prop("checked")) ? 1 : 0;
            self._storage.setValue("ShowFavorites", self._showFavourites.toString());

            //redraw layers
            if (self._overlays.get("UCRLines").getVisible()) {
                (<ImageWMS>self._overlays.get("UCRLines").getSource()).updateParams({
                    "time": Date.now(),
                    "SHOW_FAVOURITES": self._showFavourites,                   
                    "HIDE_ROUTES_OF_NO_INTEREST": self._hideRoutesOfNoInterest
                });
            }
            if (self._overlays.get("BOATLines").getVisible()) {
                (<ImageWMS>self._overlays.get("BOATLines").getSource()).updateParams({
                    "time": Date.now(),
                    "SHOW_FAVOURITES": self._showFavourites,                    
                    "HIDE_ROUTES_OF_NO_INTEREST": self._hideRoutesOfNoInterest
                });
            } 
            if (self._overlays.get("PROW-Byway").getVisible()) {
                (<ImageWMS>self._overlays.get("PROW-Byway").getSource()).updateParams({
                    "time": Date.now(),                    
                    "SHOW_BOAT_PROW": self._showBOATProw              
                });
            }              
        });
    }

    private initRoutesOfNoInterest = (): void => {
        let self = this;
        //check storage first
        self._hideRoutesOfNoInterest = parseInt(self._storage.getValue("HideRoutesOfNoInterest")) || 0;

        if (self._hideRoutesOfNoInterest === 1) {
            $("#chkHideRoutesOfNoInterest").prop("checked", true);
        }

        $("#chkHideRoutesOfNoInterest").on("change", function () {
            self._hideRoutesOfNoInterest = ($(this).prop("checked")) ? 1 : 0;
            self._storage.setValue("HideRoutesOfNoInterest", self._hideRoutesOfNoInterest.toString());

            //redraw layers
            if (self._overlays.get("UCRLines").getVisible()) {
                (<ImageWMS>self._overlays.get("UCRLines").getSource()).updateParams({
                    "time": Date.now(),
                    "SHOW_FAVOURITES": self._showFavourites,
                    "HIDE_ROUTES_OF_NO_INTEREST": self._hideRoutesOfNoInterest
                });
            }
            if (self._overlays.get("BOATLines").getVisible()) {
                (<ImageWMS>self._overlays.get("BOATLines").getSource()).updateParams({
                    "time": Date.now(),
                    "SHOW_FAVOURITES": self._showFavourites,                    
                    "HIDE_ROUTES_OF_NO_INTEREST": self._hideRoutesOfNoInterest
                });
            }     
            if (self._overlays.get("PROW-Byway").getVisible()) {
                (<ImageWMS>self._overlays.get("PROW-Byway").getSource()).updateParams({
                    "time": Date.now(),                   
                    "SHOW_BOAT_PROW": self._showBOATProw
                });
            }             
        });
    }

    private addMapControls = (map: olMap): void => {
        if (!this._hasTouch) {
            let mousePositionControl = new MousePosition({
                coordinateFormat: function (coordinate: Coordinate) {

                    let coord27700: Coordinate = olProj.transform(coordinate, "EPSG:3857", "EPSG:27700");
                    let osgb = new OSGB();
                    osgb.SetGridCoordinates(coord27700[0], coord27700[1]);
                    return osgb.GetGridRef(4);

                    //return coordinate[0].toFixed(0) + " " + coordinate[1].toFixed(0);
                },
                projection: map.getView().getProjection(),
                className: "custom-mouse-position",
                target: document.getElementById("mouse-position")
            });

            map.addControl(mousePositionControl);
        }

        map.addControl(new ScaleLine());
        let fs = document.createElement('i');
        fs.setAttribute('class', 'fas fa-expand');
        map.addControl(new FullScreen({
            label: fs
        }));
    }

    private addBaseLayers = (): void => {
        let self = this;

        this._baseLayerFactory = new BaseLayerFactory();

        let layers = [            
            this._OSMContoured = this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.OSM_ESDM_contours, "", this._osmContouredApiKey).olLayer,
            this._OSOpen = this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.OS_Open_Data).olLayer,
            this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.OSOneInch_Hills1885).olLayer,
            this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.OSOneInch_1955To1961).olLayer,
            this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.OSProvisional_1937to1961).olLayer
        ];


        let mapSettings = this._mapStore.getMapInfo();

        if (this._isMember) {

            if (this._bingSession !== null) {
                //add Bing layers for auth users
                this._BingOS = this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.BingOS, this._bingApiOrSessionKey).olLayer;
                this._BingRoad = this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.BingRoad, this._bingApiOrSessionKey).olLayer;

                layers.push(this._BingOS);
                layers.push(this._BingRoad);
                layers.push(this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.BingAerial, this._bingApiOrSessionKey).olLayer);
                layers.push(this._baseLayerFactory.GetBaseLayerByType(BaseLayerType.BingAerialWithLabels, this._bingApiOrSessionKey).olLayer);

                this._bingSession.setMap(this._map);
            }
            else {
                //hide Bing layer controls
                $("#liBingOS").hide();
                $("#liBingAerial").hide();
                $("#liBingAerialWithLabels").hide();

                mapSettings.baselayer = null;
            }            
        }       

        let layerGroup = new LayerGroup({
            //'title': 'Base maps',
            layers: layers
        });      
        let baseMapSet = false;

        layerGroup.getLayers().forEach(function (sublayer, j) {
            if (mapSettings.baselayer === sublayer.getProperties().name) {
                sublayer.setVisible(true);
                baseMapSet = true;
            }
        });

        //if the base isn't set then set the default
        if (!baseMapSet) {
            layerGroup.getLayers().forEach(function (sublayer, j) {
                if (sublayer.get("name") === "Contoured") {
                    sublayer.setVisible(true);
                    mapSettings.baselayer = "Contoured";
                }
            });
        }

        this._map.addLayer(layerGroup);

        let baseLayerRadios = $("input[name='baseLayer']");       

        $("input[name='baseLayer']").each(function (i: number, e: HTMLElement) {
            $(this).prop("checked", mapSettings.baselayer === $(this).val());
            $(this).on("click", function (e) {
                self.baseRadioClicked(e);
            });
        });

        if (self._mapStore.getMapInfo().closePanelOnBaseLayerChange === true) {
            $("#ckAutoClose").prop("checked", true);
        }
        
        $("#ckAutoClose").on("click", function () {            
            self._mapStore.onAutoCloseBaseLayerChanged($(this).prop("checked"));
        });
    }

    //Base layer changed handler
    private baseRadioClicked = (e: any): void => {
        let rdoVal = e.currentTarget.value;
        let self = this;

        this._map.getLayers().forEach(function (layer, i) {
            if (layer instanceof LayerGroup) {
                layer.getLayers().forEach(function (sublayer, j) {

                    let properties = sublayer.getProperties();
                    let visible = properties.name === rdoVal;
                    sublayer.setVisible(visible);

                    if (visible) {
                        //do this for the visible layer only                        
                        self._mapStore.onBaseLayerChanged(rdoVal, true);

                        if (self._mapStore.getMapInfo().closePanelOnBaseLayerChange === true) {
                            $("#slide-panel-btn-base-layers").trigger("click");
                        }
                    }
                });
            }
        });

        this.setBingOSView(this._map.getView().getZoom());
    }

    private onTrackingStarted = (): void => {
        const self = this;

        $("input[name='baseLayer']").each(function (index, element) {                    
            //remember the currently selected base layer
            if ($(this).prop("checked")) {
                self._selectedBaseLayerRadioId = element.id;
            }            
            $(this).prop("disabled", element.id !== "rdoOpenContours");         
        });
        $('#rdoOpenContours').trigger("click");
    }

    private onTrackingEnded = (): void => {
        const self = this;

        $("input[name='baseLayer']").each(function (index, element) {            
            if (element.id !== "rdoOpenContours") {
                $(this).prop("disabled", false);
            }
        });

        if (self._selectedBaseLayerRadioId) {
            $(`#${self._selectedBaseLayerRadioId}`).trigger("click");
            self._selectedBaseLayerRadioId = "";
        }        
    }

    private setBingOSView = (zoom: number): void => {
        const zoomInt: number = parseInt(zoom.toString());
        console.log("zoom:" + zoomInt);

        if (this._isMember && this._bingSession !== null && $('#rdoBingOS').prop("checked")) {
            //when minified we're not get whole number for the zoom level
            if (zoomInt <= 11 && this._BingOS.getVisible()) {
                //if current layer is BingOS then show BingRoad
                this._BingOS.setVisible(false);
                this._BingRoad.setVisible(true);
                this._OSOpen.setVisible(false);

            } else if (zoomInt > 11 && zoomInt < 17 && (this._BingRoad.getVisible() || this._OSOpen.getVisible() )) {
                //if current layer is BingRoad then show BingOS
                this._BingOS.setVisible(true);
                this._BingRoad.setVisible(false);
                this._OSOpen.setVisible(false);

            } else if (zoomInt >= 17 && this._BingOS.getVisible()) {
                this._BingOS.setVisible(false);
                this._BingRoad.setVisible(false);
                this._OSOpen.setVisible(true);
            }
        }
    }

    private addOverlays = (map: olMap): void => {
        let self = this;
        self._overlays = new Map<string, Layer>();

        let landRegistryAttr = "This information is subject to Crown copyright and database rights 2021 and is reproduced with the permission of HM Land Registry.</br>The polygons (including the associated geometry, namely x, y co-ordinates) are subject to Crown copyright and database rights 2021 Ordnance Survey 100026316."
        self.addOverlay(map, "LandRegistry", true);
        self._overlays.get("LandRegistry").getSource().setAttributions(landRegistryAttr);

        this.addOverlay(map, "RepAreas", false);      
        self.addOverlay(map, "HighwaysAuthorities", false);
        self.addOverlay(map, "LEGACYLines", true);        
        self.addOverlay(map, "UCRLines", true, true);       
        self.addOverlay(map, "BOATLines", true, true);   

        if(this._showBOATProw) {
            self.addOverlay(map, "PROW-Byway", true, false);   
            self._overlays.get("PROW-Byway").setVisible(true);
        }
        
        this.addOverlay(map, "RoutesWithoutComments", true, true);
        this.addOverlay(map, "OpenUSRN", true);      
        
        //set inital map layers visibility
        $("input.mapLayer").each(function () {
            let ck = $(this);
            let layerName = <string>ck.val();
            let defaultChecked = (ck.data("checked") == true);
            let isVisible = self._mapStore.isLayerVisible(layerName, defaultChecked);

            if (isVisible) {
                ck.prop("checked", isVisible);
                self._overlays.get(layerName).setVisible(true);
            }
        });    

        //now add the change handlers
        $("input.mapLayer").each(function () {
            let ck = $(this);
            ck.on("change", function () {
                let checked = $(this).is(":checked");
                let layerName = <string>$(this).val();
                self._overlays.get(layerName).setVisible(checked);
                self._mapStore.onLayerVisibiltyChanged(layerName, checked);

                if (layerName === "BOATLines" && !checked) {                                      
                    (<ImageWMS>self._overlays.get("BOATLines").getSource()).updateParams({
                        "time": Date.now(),
                        "SHOW_FAVOURITES": self._showFavourites,                        
                        "HIDE_ROUTES_OF_NO_INTEREST": self._hideRoutesOfNoInterest
                    });
                }
                if (self._showBOATProw) {
                    (<ImageWMS>self._overlays.get("PROW-Byway").getSource()).updateParams({
                        "time": Date.now(),
                        "SHOW_BOAT_PROW": self._showBOATProw
                    });
                }
            });
        });
    }

    private addOverlay = (
        map: olMap,
        layerName: string,
        queryable: boolean,
        useHideRoutesOfNoInterest: boolean = false
    ): void => {
        let layer = this.getWmsImageLayer(layerName, queryable, useHideRoutesOfNoInterest);
        layer.setVisible(false);
        this._overlays.set(layerName, layer);
        map.addLayer(this._overlays.get(layerName));

        let resolution = map.getView().getResolution();
        this.updateLegendGraphic(layer.getSource(), layerName, resolution);
    }

    private getWmsImageLayer = (
        layerName: string,
        queryable: boolean,
        useHideRoutesOfNoInterest: boolean
    ): Layer => {
        let self = this;
        let params = {
            LAYERS: layerName,
            VERSION: "1.3.0"
        };
      
        if (layerName === "PROW-Byway") {
            params["SHOW_BOAT_PROW"] = self._showBOATProw;
        }

        if (useHideRoutesOfNoInterest) {
            params["HIDE_ROUTES_OF_NO_INTEREST"] = self._hideRoutesOfNoInterest;
        }

        if (layerName === "UCRLines" || layerName === "BOATLines") {
            params["SHOW_FAVOURITES"] = self._showFavourites;
        }        

        let source = new ImageWMS({
            projection: self._map.getView().getProjection(),
            url: self._wfsUrl,
            params: params,
            serverType: "mapserver",
            ratio: 1.5
        });

        source.on('imageloadstart', function () {
            self.onLayerLoading();
        });
        source.on('imageloadend', function () {
            self.onLayerLoaded();
        });
        source.on('imageloaderror', function () {
            self.onLayerLoaded();
        });

        let lyr = new ImageLayer({
            source: source
        });

        lyr.set("queryable", queryable, true);

        return lyr
    }

    private updateLegendGraphic = (wmsSource, layerName: string, resolution: number): void => {
        let img = <HTMLImageElement>document.getElementById('legend_' + layerName);
        if (img) {
            let graphicUrl = wmsSource.getUrl(resolution) + "?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=" + layerName;
            //console.log(graphicUrl);
            img.src = graphicUrl;
        }
    }

    private onLayerLoading = (): void => {
        this._loadingCount += 1
        $("#mapLoader").show();
    }

    private onLayerLoaded = (): void => {
        this._loadingCount -= 1;
        if (this._loadingCount === 0) {
            $("#mapLoader").hide("slow");
        }
    }

    private toolRadioClicked = (ele: HTMLElement, ev: MouseEvent): void => {
        let rdoVal = (<HTMLInputElement>ele).value;

        switch (rdoVal) {
            case "measureKm":
                this._contextMenu.deactivate();
                this._measureInKm = true;
                this.addMeasureInteraction();
                break;

            case "measureMiles":
                this._contextMenu.deactivate();
                this._measureInKm = false;
                this.addMeasureInteraction();
                break;

            default:
                this.removeMeasureInteraction();
                //enable context menu
                this._contextMenu.activate();
        }
        this._mapStore.onCurrentToolChanged(rdoVal);
    }

    private addMeasureInteraction = (): void => {
        if (this._draw !== null) {
            //already initiated
            return;
        }
        let self = this;
        let source = new VectorSource();

        this._measureLayer = new VectorLayer({
            source: source,
            //id: 'measure-tool',
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)'
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                        color: '#ffcc33'
                    })
                })
            })
        });

        this._measureLayer.set("id", "measure-tool", true);
        this._map.addLayer(this._measureLayer);
        this._measureLayer.setVisible(true);

        let formatLength = function (line) {
            let length = olSphere.getLength(line);
            let output;

            if (self._measureInKm) {
                if (length > 100) {
                    output = (Math.round(length / 1000 * 100) / 100) +
                        ' ' + 'km';
                } else {
                    output = (Math.round(length * 100) / 100) +
                        ' ' + 'm';
                }
            } else {
                //miles
                output = (Math.round((length * 0.0006213712) * 100) / 100) + ' mile(s)';
            }

            return output;
        };

        this._draw = new Draw({
            source: source,
            type: GeometryType.LINE_STRING,
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                }),
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.5)',
                    lineDash: [10, 10],
                    width: 2
                }),
                image: new Circle({
                    radius: 5,
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 0, 0.7)'
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.2)'
                    })
                })
            })
        });

        this._map.addInteraction(this._draw);
        this.createMeasureTooltip();
        this.createHelpTooltip();

        let listener;
        this._draw.on('drawstart',
            function (evt: DrawEvent) {

                let measureRdo = $("#rdoToolMeasureKm").is(':checked') || $("#rdoToolMeasureMiles").is(':checked');
                if (!measureRdo) {
                    //nothing to do 
                    return;
                }
             
                // set sketch
                self._sketch = evt.feature;

                /** @type {ol.Coordinate|undefined} */
                //let tooltipCoord = evt.coordinate;
                let tooltipCoord;

                listener = self._sketch.getGeometry().on('change', function (evt) {
                    let geom = evt.target;
                    let output;
                    if (geom instanceof LineString) {
                        output = formatLength(geom);
                        tooltipCoord = geom.getLastCoordinate();
                    }
                    self._measureTooltipElement.innerHTML = output;
                    self._measureTooltip.setPosition(tooltipCoord);
                });
            });

        this._draw.on('drawend',
            function () {
                self._measureTooltipElement.className = 'tooltip tooltip-static';
                self._measureTooltip.setOffset([0, -7]);
                // unset sketch
                self._sketch = null;
                // unset tooltip so that a new one can be created
                self._measureTooltipElement = null;
                self.createMeasureTooltip();
                unByKey(listener);
            });
    }

    private removeMeasureInteraction = (): void => {
        if (this._measureLayer) {
            this._measureLayer.setVisible(false);
        }

        if (this._draw) {
            this._map.removeInteraction(this._draw);
        }

        this._draw = null;

        $('.tooltip-static').remove();

        if (this._measureTooltip) {
            this._map.removeOverlay(this._measureTooltip);
        }

        if (this._measureTooltipElement) {
            this._measureTooltipElement.className = 'tooltip tooltip-measure hidden';
            this._measureTooltipElement.parentNode.removeChild(this._measureTooltipElement);
        }

        if (this._helpTooltipElement) {
            this._helpTooltipElement.parentNode.removeChild(this._helpTooltipElement);
        }
    }

    private handleClick = (evt: MapBrowserEvent): void => {

        //let gridRefRdo = document.getElementById("rdoToolGridRef");
        //if (gridRefRdo.checked === true) {
        //    $("#txtGridRef").val(mapGridRef.getGridRef(evt.coordinate));
        //    return;
        //}
        let self = this;
        let html: string = "";
        let measureRdo = $("#rdoToolMeasureKm").is(':checked') || $("#rdoToolMeasureMiles").is(':checked');
        if (measureRdo) {
            //nothing to do 
            return;
        }

        //show message for unauthenticated users
        if (self._isMember === false) {
            if (self._isAuthenticated === false) {
                html = self.htmlForLoginRegisterPrompt();
            }
            else {
                html = self.htmlForNonMemberPrompt();
            }
            return;
        }

        let callback = function () {
            self._mapHighlight.highlightFeaturesAtEvent(evt, window["routeids"], window["legacyrouteids"], window["landregistryids"]);
        }

        window["routeids"] = [];
        window["legacyrouteids"] = [];
        window["landregistryids"] = [];       
        self._mapFeatureInfo.showFeaturesAtEvent(self._map, evt, callback);
    }

    private handlePointerMove = (evt: MapBrowserEvent): void => {
        if (evt.dragging) {
            return;
        }

        let measureRdo = $("#rdoToolMeasureKm").is(':checked') || $("#rdoToolMeasureMiles").is(':checked');
        if (!measureRdo) {
            //nothing to do 
            return;
        }

        let helpMsg = 'Click to start drawing';
        if (this._sketch !== null) {
            helpMsg = "Double click to finish drawing";
        }

        this._helpTooltipElement.innerHTML = helpMsg;
        this._helpTooltip.setPosition(evt.coordinate);
        this._helpTooltipElement.classList.remove('hidden');
    }

    private htmlForLoginRegisterPrompt = (): string => {
        let htmlContent = `<div class='small incidentPopupRow'>
                         Please <a href='${this._loginUrl}'>Login</a> or <a href='${this._registerUrl}'>Register</a> to see route details.  <a href='/registering-with-trailwise'>Find out more...</a>
                       </div>`;

        return htmlContent;
    }

    private htmlForNonMemberPrompt = (): string => {
        let htmlContent = `<div class='small incidentPopupRow'>
                         If you have lost the ability to use all features of TW2 your GLASS membership has likely expired.
                       </div>`;

        return htmlContent;
    }

    private createHelpTooltip = (): void => {
        if (this._helpTooltipElement && this._helpTooltipElement.parentNode) {
            this._helpTooltipElement.parentNode.removeChild(this._helpTooltipElement);
        }
        this._helpTooltipElement = document.createElement('div');
        this._helpTooltipElement.className = 'tooltip hidden';
        this._helpTooltipElement.innerHTML = 'Shift click to start drawing';
        this._helpTooltip = new Overlay({
            element: this._helpTooltipElement,
            offset: [15, 0],
            positioning: OverlayPositioning.CENTER_LEFT,
            //autoPan: true,
            //autoPanMargin: 150
        });
        this._map.addOverlay(this._helpTooltip);
    }

    private createMeasureTooltip = (): void => {
        if (this._measureTooltipElement && this._measureTooltipElement.parentNode) {
            this._measureTooltipElement.parentNode.removeChild(this._measureTooltipElement);
        }
        this._measureTooltipElement = document.createElement('div');
        this._measureTooltipElement.className = 'tooltip tooltip-measure hidden';
        this._measureTooltip = new Overlay({
            element: this._measureTooltipElement,
            offset: [0, -15],            
            positioning: OverlayPositioning.BOTTOM_CENTER,
            autoPan: true,
            autoPanMargin: 150
        });
        this._map.addOverlay(this._measureTooltip);
    }

    private checkAuthStatus = (): void => {
        $.ajax({
            url: '/api/isauthenticated',
            dataType: "json"
        })
            .done(function (response) {
                if (response === false) {
                    //refresh the page so map enforces rule for anonymous
                    location.reload();
                }
            })
            .fail(function (err) {
                //alert(err);
            });
    }

}